import { PasswordConfirm } from "@/components/PasswordConfirm";
import { useAuth } from "@/context/AuthContext";
import { useUsuarios } from "./usuarios/useUsuarios";
import { UsuariosNewUserCard } from "./usuarios/UsuariosNewUserCard";
import { UsuariosTable } from "./usuarios/UsuariosTable";
import { UsuarioEditDialog } from "./usuarios/UsuarioEditDialog";
import { SavePresetDialog, BulkDeleteBar } from "./usuarios/SavePresetDialog";

// Página de Usuários — apenas orquestração. Estado e mutações vivem em useUsuarios.
// Sub-componentes: UsuariosNewUserCard (form de criação), UsuariosTable (listagem),
// UsuarioEditDialog (edição), SavePresetDialog (preset custom), BulkDeleteBar (exclusão em massa).
export default function Usuarios() {
  const { currentEmpresaId } = useAuth();
  const u = useUsuarios(currentEmpresaId);
  return (
    <div className="space-y-6" data-testid="page-usuarios">
      <h1 className="text-4xl font-extrabold">Usuários</h1>

      <UsuariosNewUserCard
        f={u.f} setF={u.setF}
        entregadores={u.entregadores} empresas={u.empresas} customPresets={u.customPresets}
        onAdd={u.add}
        onTogglePerm={u.togglePerm} onToggleEmpresa={u.toggleEmpresa}
        onSetAllPerms={u.setAllPerms} onApplyPreset={u.applyPreset}
        onOpenSavePreset={u.openSavePreset} onDeleteCustomPreset={u.deleteCustomPreset}
      />

      <UsuariosTable
        items={u.items} selectedIds={u.selectedIds}
        onToggleSel={u.toggleSel} onToggleAllSel={u.toggleAllSel}
        onGenResetLink={u.genResetLink} onOpenEdit={u.openEdit} onAskDelete={u.askDelete}
      />

      <UsuarioEditDialog
        open={!!u.editUser} onClose={() => u.setEditUser(null)}
        editForm={u.editForm} setEditForm={u.setEditForm}
        entregadores={u.entregadores} empresas={u.empresas} customPresets={u.customPresets}
        onSave={u.saveEdit}
        onTogglePerm={u.togglePerm} onToggleEmpresa={u.toggleEmpresa}
        onSetAllPerms={u.setAllPerms} onApplyPreset={u.applyPreset}
        onOpenSavePreset={u.openSavePreset} onDeleteCustomPreset={u.deleteCustomPreset}
      />

      <SavePresetDialog
        open={!!u.savePresetOpen} onClose={() => u.setSavePresetOpen(null)}
        name={u.savePresetName} onNameChange={u.setSavePresetName}
        permissionsCount={u.savePresetOpen?.permissions?.length}
        currentEmpresaId={currentEmpresaId}
        onConfirm={u.confirmSavePreset}
      />

      <PasswordConfirm
        open={!!u.pwdConfirm} onClose={() => u.setPwdConfirm(null)}
        onConfirmed={() => u.pwdConfirm?.action?.()}
        message={u.pwdConfirm?.message} resource={u.pwdConfirm?.resource}
        action={u.pwdConfirm?.verifyAction || "e"} />

      <BulkDeleteBar
        count={u.selectedIds.size}
        onCancel={() => u.setSelectedIds(new Set())}
        onDelete={() => u.setPwdConfirm({
          action: u.bulkDelete,
          message: `Digite as credenciais de um usuário autorizado a excluir ${u.selectedIds.size} usuário(s):`,
          resource: "users", verifyAction: "e",
        })}
      />
    </div>
  );
}
